import React,{useState, useEffect} from 'react'
import {Box,TextInput, Form, FormField,Select} from 'grommet'
import { User, MailOption, Lock} from 'grommet-icons';
import {RequestButton} from './utils/shared/shipmentViewFunctions'
import {APIRequest} from './utils/shared/requests'
import { withRouter } from 'react-router-dom';

function EditUserForm (props) {
    const [labs, setLabs] = useState([]);
    const [customers, setCustomers] = useState([]);
  useEffect(() => { 
    APIRequest('/labs').then(result => setLabs(result))
    APIRequest('/customers').then(result => setCustomers(result))
   },[]);
  return ( 
    <Form value={props.value} onSubmit={props.handleSubmit} onChange={nextValue => props.handleChange(nextValue)}>
    <Box direction='row' justify="center" flex="grow" margin={{top: 'large'}}>
        <FormField required label='Username' name='username' margin='small' >
            <TextInput icon={<User />} name='username' placeholder="Enter Username" />
        </FormField>
        <FormField required label='Email' name='email' margin='small' >
            <TextInput icon={<MailOption />} name='email' placeholder="Enter Email" />
        </FormField>
        <FormField label='Password' name='password' margin='small' >
            <TextInput icon={<Lock />} name='password' type='password' placeholder="Enter Password" />
        </FormField>
        {(props.locationType === 'lab' ? <FormField name="lab" label="Select Lab" margin='small'> <Select id="select" placeholder={`${props.lab.name}`}labelKey="name" options={labs} value={props.lab} onChange={({ option }) => props.handleLabChange(option)} /> </FormField>: <FormField disabled name="lab" label={`Lab: ${props.lab.name}`} margin='small'> <Select disabled id="select" placeholder={`${props.lab.name}`}labelKey="name" options={labs} value={props.lab} onChange={({ option }) => props.handleLabChange(option)} /> </FormField>)}
        {(props.locationType === 'customer' ? <FormField name="customer" label="Select Customer" margin='small'><Select id="select" placeholder={`${props.customer.name}`}labelKey="name" options={customers} value={props.customer} onChange={({ option }) => props.handleCustomerChange(option)} /></FormField> : null )}
        <FormField name="enabled" label="User Active" margin='small'> <Select name='enabled' id="select" value={props.value.enabled.toString()} options={['true', 'false']} /> </FormField>
        <FormField margin='small' label='User Role'><TextInput disabled margin='small' style={{fontWeight:'bold', color:'black', opacity:3}} placeholder={props.userRole} /> </FormField>
    </Box>
    <Box direction='row' justify="between" margin={{top: 'medium'}}>
      <RequestButton load={props.load} label={"Update User"} />
    </Box>
    
   </Form>

  )
}

export default withRouter(EditUserForm)
